module.exports = __webpack_public_path__ + "img/user21.e76aed32.jpg";